import React from 'react';
import { Link } from 'react-router-dom';

import { Icon } from '@atlas/ui';

import { defaultRoutes } from 'components/MainRouter/constants';

const { menu } = defaultRoutes;

const LuckyDayBack = ({ name }) => (
  <Link className="back-to-container ellipsis" to={menu}>
    <Icon className="icon-back" name="back" />
    <h1 className="title-text">{name}</h1>
  </Link>
);

export default LuckyDayBack;
